export const DATE_FORMAT = {
  WITH_WEEKDAY: 'M/d\nE',
  WITHOUT_WEEKDAY: 'M/d',
  YEAR_MONTH: 'yyyy/MM',
} as const;
export type DateFormat = typeof DATE_FORMAT[keyof typeof DATE_FORMAT];
